
import request from '../untils/request.js'

// 用户登录接口
export const login = data => {
    return request({
        method: 'POST',
        url: '/lsg-auth/auth/login',
        // headers:{
        //    Authorization: user.token 
        // },
        //data用来设置POST请求体
        data
      
    })

}

//获取验证码接口
export const CodeInfo = () => {
    return request({
        method: 'GET',
        url: '/lsg-auth/auth/getVerificationCodeInfo',
        
    })

}
//发送手机验证码接口
export const CodeIphone = params => {
    return request({
        method: 'GET',
        url: '/lsg-auth/auth/sendPhoneVerificationCode',
        params
    })

}

// 用户退出登录接口
export const God = () => {
    return request({
        method: 'GET',
        url: '/lsg-auth/auth/logout',     
    })

}


// 获取用户信息
// export const getUserProfile = () => {
//     // const user = JSON.parse(window.localStorage.getItem('user'))
//     // console.log(user)
//     return request({
//         method: 'GET',
//         url: '/mp/v1_0/user/profile'
//             // 后端要求把需要授权七年的用户身份放到请求头中
//             // axios可以通过headers选项设置请求头
//             // headers: {
//             //     //属性名和值都得看后端的要求
//             //     //属性名：Authorization ，接口要求的
//             //     //属性值：Bearer空格token数据
//             //     Authorization: `Bearer ${user.token}`
//             // }
//     })
// }
